const clean = value => String(value ?? '').trim();

export function referenceUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}

// Plain text is passed to Shopify's contact form, never treated as proof approval.
export function buildQuoteContact({kind, title, draft, product, scentLabel, references = []}) {
  const rows = [['Request', title], ['Engraving style', clean(draft['car-style'])]];
  if (kind === 'auto') rows.push(['Vehicle', clean(draft['car-details'])]);
  if (draft['quote-material']) rows.push(['Wood preference', clean(draft['quote-material'])]);
  rows.push(['Details', clean(draft['quote-details'])], ['Front engraving', clean(draft['quote-text'])]);
  const format = product?.scent ? draft['quote-format'] : kind === 'key' ? 'Key fob' : 'To be agreed in your quote';
  rows.push(['Product option', format]);
  if (product?.scent && format === 'Scented air freshener') rows.push(['Preferred scent', scentLabel]);
  if (draft.back) clean(draft['quote-back-message']).split(/\r?\n/).forEach((line, index) => rows.push(['Back message line ' + (index + 1), clean(line) || '(blank line)']));
  rows.push(['Quantity', clean(draft['quote-quantity'])]);
  const urls = [...new Set(references.map(referenceUrl).filter(Boolean))];
  const body = rows.filter(([, value]) => value).map(([label, value]) => label + ': ' + value).join('\n')
    + '\n\nReferences:\n' + (urls.length ? urls.join('\n') : 'None provided')
    + '\n\nPrice: quoted after review. No payment taken.\nWorkflow: review > quote > payment > proof approval > production.';
  return { name:clean(draft['quote-name']), email:clean(draft['quote-email']), body, references:urls };
}

export function quoteCanSubmit({enabled, uploadsEnabled, widgetReady, selectedLocalFiles, quantity}) {
  // Never submit a request while silently discarding locally selected reference files.
  return Boolean(enabled && uploadsEnabled && widgetReady && selectedLocalFiles === 0
    && Number.isSafeInteger(quantity) && quantity > 0);
}

export function quoteUploadsReady({states, referenceCount}) {
  // Every visible uploader item must have a completed reference; errors must be removed.
  return Number.isSafeInteger(referenceCount) && referenceCount >= 0
    && states.length === referenceCount && states.every(state => state === 'processing-complete');
}

export function quoteReturnPath({pathname, template, kind, themeId}) {
  const safePath = pathname.startsWith('/') && !pathname.startsWith('//') ? pathname : '/';
  const query = new URLSearchParams({view:'vador-' + template, request:'custom', context:kind, contact_posted:'true', preview_theme_id:String(themeId)});
  return safePath + '?' + query + '#quote-form';
}
